import { NgModule } from '@angular/core';
import { BreadcrumbComponent } from './breadcrumb.component';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';

@NgModule({
  imports: [CommonModule, RouterModule, BreadcrumbComponent],
  exports: [BreadcrumbComponent],
  declarations: [],
  providers: [],
})
export class BreadcrumbModule { }
